import React, { useState } from 'react';
import { colors } from '../styles';

const styles = {
  container: {
    marginBottom: '1rem',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.75rem 0',
    cursor: 'pointer',
    userSelect: 'none',
    borderBottom: `1px solid ${colors.border}`,
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  title: {
    fontSize: '0.75rem',
    fontWeight: 600,
    color: colors.textMuted,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    margin: 0,
  },
  arrow: {
    fontSize: '0.625rem',
    color: colors.textMuted,
    transition: 'transform 0.2s ease',
  },
  arrowOpen: {
    transform: 'rotate(90deg)',
  },
  content: {
    overflow: 'hidden',
    transition: 'max-height 0.3s ease, opacity 0.3s ease, padding 0.3s ease',
  },
  contentOpen: {
    maxHeight: '1000px',
    opacity: 1,
    paddingTop: '0.75rem',
  },
  contentClosed: {
    maxHeight: '0',
    opacity: 0,
    paddingTop: '0',
  },
};

export default function CollapsibleSection({ title, children, defaultOpen = false }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div style={styles.container}>
      <div
        style={styles.header}
        onClick={() => setIsOpen(!isOpen)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setIsOpen(!isOpen);
          }
        }}
      >
        <div style={styles.headerLeft}>
          <span style={{
            ...styles.arrow,
            ...(isOpen ? styles.arrowOpen : {}),
          }}>
            ▶
          </span>
          <h2 style={styles.title}>{title}</h2>
        </div>
      </div>
      <div style={{
        ...styles.content,
        ...(isOpen ? styles.contentOpen : styles.contentClosed),
      }}>
        {children}
      </div>
    </div>
  );
}
